import { useMutation } from '@apollo/client';
import { GET_PATIENTS } from '../gqlSchemes/getPatients';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { REINVITE_PATIENT } from '../gqlSchemes/reinvitePatient';

export default function useReinvitePatient() {
  const [reinvite] = useMutation(REINVITE_PATIENT);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const reinvitePatient = ({ id }) => {
    reinvite({
      variables: {
        record: {
          id,
        },
      },
      onCompleted: async (res) => {
        if (res.user.patientUser.reinvitePatient.ok) {
          enqueueSnackbar(t('Patient was successfully reinvited'), {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
          });
        } else {
          enqueueSnackbar(res.user.patientUser.activatePatient.error.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
          });
        }
      }
    });
  };

  return { reinvitePatient };
}
